import React from 'react';
import styled from 'styled-components';

import { useNavigateWithContext } from 'state';
import useAudience from 'hooks/useAudience';
import Property from 'components/property';
import Icon from 'components/icon';
import SectionDescription from './section-description';
import useMobile from 'hooks/useMobile';
import { useLoginContext } from '../login-context';

const StyledProperty = styled(Property)`
  width: 100%;
  flex-shrink: 0;
  overflow: auto;
  ${({ isMobile }) => (isMobile ? '' : `max-width:375px;`)}
`;
const StyledLoader = styled(Icon)`
  width: 100%;
  margin: auto;
  flex-shrink: 0;
  ${({ isMobile }) => (isMobile ? '' : `max-width:375px;`)}
`;

const PropertyPanel = ({ isMobile }) => {
  const navigate = useNavigateWithContext();
  const { location, dataFetched, failedFetch } = useLoginContext();

  if (!location || failedFetch) {
    return <SectionDescription />;
  }

  if (!dataFetched) {
    return (
      <StyledLoader name="fa-duotone fa-spinner-third fa-spin" size={100} isMobile={isMobile} />
    );
  }

  return (
    <StyledProperty
      location={location}
      forceDisplay={true}
      isMobile={isMobile}
      onChangeProperty={() => navigate('locations')}
    />
  );
};

export default () => {
  const { isTabletOrMobile } = useMobile();
  const [audience] = useAudience();

  if (audience?.uuid === 'approver') {
    return <SectionDescription />;
  }

  // Don't show property selector on mobile views, it's too noisy
  if (isTabletOrMobile) {
    return <></>;
  }

  return <PropertyPanel isMobile={isTabletOrMobile} />;
};
